module.exports = __webpack_public_path__ + "img/carousel-clientes-13.6eff2068.png";